import * as React from 'react';
import { Checkbox } from '@cian/ui-kit/checkbox';
import { UiKitContext } from '@cian/ui-kit/internal/context';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var CheckMark = function CheckMark(_ref) {
  var checked = _ref.checked;
  var context = React.useMemo(function () {
    return {
      deviceType: 'phone',
      useStaticDeviceType: true
    };
  }, []);
  return /*#__PURE__*/_jsx(UiKitContext.Provider, {
    value: context,
    children: /*#__PURE__*/_jsx("div", {
      className: styles['container'],
      children: /*#__PURE__*/_jsx(Checkbox, {
        checked: checked
      })
    })
  });
};
CheckMark.displayName = 'CheckMark';